import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

type DatePickerReadViewProps = {
	displayDate: string;
	testId?: string;
};

export const DatePickerReadView = ({
	displayDate,
	testId,
}: DatePickerReadViewProps): React.JSX.Element => (
	<ReadViewContainer>
		<ReadViewItem data-testid={testId}>{displayDate}</ReadViewItem>
	</ReadViewContainer>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ReadViewContainer = styled.div<{
	children: ReactNode;
}>({
	display: 'flex',
	flexDirection: 'column',
	minWidth: '128px',
	paddingTop: token('space.100'),
	paddingRight: '0px',
	paddingBottom: token('space.100'),
	paddingLeft: '0px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ReadViewItem = styled.span<{
	children: ReactNode;
	['data-testid']?: string;
}>({
	paddingRight: token('space.050'),
});
